import { motion } from "framer-motion";
import { STORY_IMG } from "../../data";
import { useLang } from "../../i18n";

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t.story.chapters;
  return (
    <section id="story" data-testid="story-section" className="relative px-6 md:px-12 py-28 md:py-44">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-5 md:sticky md:top-28 self-start">
          <motion.div initial={{ opacity: 0, scale: 1.05 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden aspect-[4/5] rounded-sm">
            <img src={STORY_IMG} alt="Lilah at work" className="w-full h-full object-cover" />
          </motion.div>
          <p className="overline text-[0.55rem] mt-4 text-[#2D2A26]/50">{t.story.behind}</p>
        </div>

        <div className="md:col-span-7 md:pl-10">
          <motion.p variants={fade} custom={0} initial="hidden" whileInView="show" viewport={{ once: true }} className="overline text-[#E2725B] mb-8">
            {t.story.overline}
          </motion.p>

          <div className="space-y-16 md:space-y-24">
            {chapters.map((c, i) => (
              <motion.div key={i} variants={fade} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="border-t border-[#2D2A26]/15 pt-8 grid grid-cols-[auto_1fr] gap-6 md:gap-12" data-testid={`chapter-${i}`}>
                <span className="font-serif-display text-4xl md:text-6xl text-[#E2725B]/80 leading-none">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif-display text-3xl md:text-5xl font-light tracking-tight mb-4">{c.title}</h3>
                  <p className="text-[#2D2A26]/70 text-base md:text-lg leading-relaxed max-w-xl">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
